import classNames from 'classnames';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';

import css from './BooksRequestAlert.module.scss';

interface Props {
  className?: string;
}

const BooksRequestAlert = ({ className, intl }: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksRequestAlert, className);

  return (
    <div className={classes}>
      <span className={css.BooksRequestAlert__Title}>
        {intl.formatMessage({ id: 'books.forms.requestAlertTitle' })}
      </span>
      <span className={css.BooksRequestAlert__Note}>
        {intl.formatMessage({ id: 'books.forms.requestAlertNote' })}
      </span>
      <span className={css.BooksRequestAlert__Text}>
        <FormattedMessage
          id="books.forms.requestAlertText"
          values={{
            list: (
              <span className={css.BooksRequestAlert__Emphasis}>
                {intl.formatMessage({ id: 'books.forms.bookingList' })}
              </span>
            ),
          }}
        />
      </span>
    </div>
  );
};

export default injectIntl(BooksRequestAlert);
